import * as d3 from 'd3';
import {getGoogleColorByString, nFormatter} from '@/utils/d3Utils'

export default function BarChart(data, options) {

    const cfg = {
        barLabelRotation: 45
    };

    copyOptions(options);

    let colors, x, y;

    const svg = d3.select(options.container).append("svg");

    const g = svg.append("g");

    updateBarChartParams();

    const tooltip = d3.select("body").append("div").attr("class", "toolTip");

    draw(data);

    function copyOptions(options) {
        if ('undefined' !== typeof options)
            for (let i in options) if (options.hasOwnProperty(i) && 'undefined' !== typeof options[i])
                cfg[i] = options[i];
    }

    function updateBarChartParams(isRedraw) {
        colors = (cfg.colored) ? getGoogleColorByString : d3.scaleOrdinal().range(["#1480f6"]);
        cfg.padding.bottom += isRedraw ? 0 : 20;
        x = d3.scaleBand().rangeRound([0, cfg.width - cfg.padding.left - cfg.padding.right]).padding(0.1);
        y = d3.scaleLinear().rangeRound([cfg.height - cfg.padding.top - cfg.padding.bottom, 0]);

        svg.attr("width", cfg.width).attr("height", cfg.height);
        g.attr("transform", "translate(" + cfg.padding.left + "," + cfg.padding.top + ")");
    }


    function draw(data) {
        g.selectAll("*").remove();

        x.domain(data.map(d => d[cfg.label]));
        y.domain([0, d3.max(data, d => d[cfg.value]) * 1.1]);

        g.append("g")
            .attr("class", "axis axis--y")
            .call(d3.axisLeft(y).tickFormat(v => nFormatter(v, 1)))
            .append("text")
            .attr("transform", "rotate(-90)")
            .attr("y", 6)
            .attr("dy", "0.71em")
            .attr("text-anchor", "end")
            .text("");

        g.append("text")
            .attr("text-anchor", "middle")
            .attr("transform", "translate(" + (-cfg.padding.left / 2) + "," + ((cfg.height - cfg.padding.bottom - cfg.padding.top) / 2 + cfg.padding.top) + ")rotate(-90)")
            .text(cfg.axisLabels.y);

        g.append("text")
            .attr("text-anchor", "middle")
            .attr("transform", "translate(" + ((cfg.width - cfg.padding.left - cfg.padding.right) / 2 + cfg.padding.right) + "," + (cfg.height - 40) + ")")
            .text(cfg.axisLabels.x);

        g.selectAll(".bar")
            .data(data)
            .enter().append("rect")
            .attr("class", "bar")
            .attr("x", d => x(d[cfg.label]))
            .attr("y", d => y(d[cfg.value]))
            .attr("width", x.bandwidth())
            .attr("height", d => {
                const height = cfg.height - cfg.padding.top - cfg.padding.bottom - y(d[cfg.value]);
                return height > 0 ? height : 0;
            })
            .attr("fill", d => colors(d[cfg.label])).style("opacity", 0.7)
            .on("mousemove", function (d) {
                if (cfg.tooltip)
                    tooltip
                        .style("left", d3.event.pageX - 50 + "px")
                        .style("top", d3.event.pageY - 70 + "px")
                        .style("display", "inline-block")
                        .html(nFormatter(d[cfg.value], 1));

                d3.select(this).style("opacity", 1);
            })
            .on("mouseout", function (d) {
                if (cfg.tooltip)
                    tooltip.style("display", "none");
                d3.select(this).style("opacity", 0.7);
            });

        g.append("g")
            .attr("transform", "translate(" + cfg.padding.left + "," + cfg.padding.top + ")")
            .selectAll(".textlabel")
            .data(data)
            .enter()
            .append("text")
            .attr("class", "textlabel")
            .attr('text-anchor', 'middle')
            .attr("x", d => x(d[cfg.label]) - cfg.padding.left + x.bandwidth() / 2)
            .attr("y", d => y(d[cfg.value]) - cfg.padding.top - 10)
            .text(d => nFormatter(d[cfg.value], 1));

        const axisXLabels = g.append("g").attr("class", "axisXLabels")
            .attr("transform", "translate(" + cfg.padding.left + "," + cfg.padding.top + ")");

        axisXLabels
            .selectAll(".axisXLabel")
            .data(data)
            .enter()
            .append("text")
            .attr("class", "axisXLabel")
            .style("text-anchor", cfg.barLabelRotation >= 90 ? "start" : "end")
            .style("font-size", 12)
            .attr("transform", d => {
                const translate = "translate(" + (x(d[cfg.label]) - cfg.padding.left + x.bandwidth() / 2) + "," + (cfg.height - cfg.padding.top - cfg.padding.bottom) + ")";

                if (cfg.barLabelRotation < 1)
                    return translate + "rotate(0)";
                else if (cfg.barLabelRotation < 90)
                    return translate + "rotate(-" + cfg.barLabelRotation + ")";
                else if (cfg.barLabelRotation >= 90)
                    return translate + "rotate(" + (cfg.barLabelRotation - 90) + ")";
            })
            .text(d => d[cfg.label]);

        if (cfg.padding.bottom - 20 < axisXLabels.node().getBBox().height) {
            cfg.padding.bottom = axisXLabels.node().getBBox().height + 40;
            updateBarChartParams();
            draw(data);
        }
    }

    this.redraw = function (data, options) {
        copyOptions(options);
        updateBarChartParams(true);
        g.selectAll("*").remove();
        draw(data);
    };
}
